/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountResExcerptDto } from '../../models/account-res-excerpt-dto';
import { UpdateMePasswordDto } from '../../models/update-me-password-dto';

export interface UserControllerUpdatePasswordPersonale$Params {
  body: UpdateMePasswordDto;
}

export function userControllerUpdatePasswordPersonale(
  http: HttpClient,
  rootUrl: string,
  params: UserControllerUpdatePasswordPersonale$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AccountResExcerptDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    userControllerUpdatePasswordPersonale.PATH,
    'patch',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AccountResExcerptDto>;
      }),
    );
}

userControllerUpdatePasswordPersonale.PATH = '/user/password';
